module.exports = __webpack_public_path__ + "img/7559123.bf994131.png";